export default __webpack_public_path__ + "static/media/ocean-bg-3.b4f5dc13.jpeg";